module.exports = "<div>\n  <span class='tag'\n    [class.selected]='isSelectedMain'\n    (click)='switch()'>\n    {{mainTag['title']}}\n  </span>\n</div>\n<div *ngIf='isSelectedMain'\n  class='subtags'>\n  <span *ngFor='let st of subTags'\n    class='subtag'\n    [class.selected]='isSelectedSubtag(st)'\n    (click)='switch(st[\"id\"])'>\n    {{st['title']}}\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/r-tag-group/r-tag-group.component.html
// module id = ../../../../../src/app/r-tag-group/r-tag-group.component.html
// module chunks = main